var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"rounded-lg card",attrs:{"width":_vm.$store.getters.mobile == 'xs' || _vm.$store.getters.mobile == 'md' ? 250 : 300,"type":"card"}})}
var staticRenderFns = []

export { render, staticRenderFns }